/*###########################################################################
// Scroll to
//#########################################################################*/

export const scrollTo = (scrollTarget, offset = 0) => {
    let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
    let scrollDistance = 0

		if (scrollTarget instanceof Element) {
			let elementTop = scrollTarget.getBoundingClientRect().top
			scrollDistance = elementTop + scrollTop + offset
		} else if (Number.isInteger(scrollTarget)) {
			scrollDistance = scrollTarget + scrollTop + offset
		}

		window.lenis.scrollTo(scrollDistance, {
			duration: 1,
			lock: true
		})
}
